import { render } from "./TileGameHome.vue?vue&type=template&id=a8b71de4"
import script from "./TileGameHome.vue?vue&type=script&lang=js"
export * from "./TileGameHome.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__